import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Text } from "../../Text";
export const Label = styled(Text).attrs({
    renderAs: "label",
}) `
  color: ${color.font.label.default};
  line-height: ${size.lineHeight.label.default};
  font-size: ${size.font.label};
  font-weight: bold;

  &[for] {
    cursor: pointer;
  }

  &.inverse {
    color: ${color.font.text.inverse.default};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9MYWJlbC9zdHlsZWQvTGFiZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUM3RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sWUFBWSxDQUFDO0FBRWxDLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsS0FBSyxDQUFDO0lBQ3RDLFFBQVEsRUFBRSxPQUFPO0NBQ2xCLENBQUMsQ0FBQTtXQUNTLEtBQUssQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU87aUJBQ2xCLElBQUksQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLE9BQU87ZUFDL0IsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLOzs7Ozs7OzthQVFqQixLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTzs7Q0FFM0MsQ0FBQyJ9